import { findIndex } from "lodash"
//import sendxAPI from '../../../xAPI'

const templateState = {
    id: -1,
    type: null,
    volume: 0,
    minVol: 0,
    maxVol: 100,
    volChange: 1,
    solution: null,
    solutionAlias: null,
    tipAttached: false,
    tipUsed: false,
    prevSolution: null,
    controlsVisible: false,
    held: false,
    imgPath: "",
    plungerPosition: "At Rest",
    animatingOut: true,
    currentPlungerPos: 0,
    description: "",
};

export function PipetteReducer(state = { pipettes: [] }, action) {
  let currentPipette;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_PIPETTE" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
          if(state.protocolSection.scene.apparatus.hasOwnProperty("pipettes")){
            currentPipette = state.protocolSection.scene.apparatus.pipettes[findIndex(state.protocolSection.scene.apparatus.pipettes, { id: action.payload.id })]
          }
      }
  }

  switch (action.type) {

      case 'CREATE_PIPETTE':

          //Create new obj from template state
          let newObj = { ...templateState, ...action.payload.props }

          if(protocolSection.scene.apparatus.hasOwnProperty("pipettes")){
            protocolSection.scene.apparatus.pipettes = [ ...protocolSection.scene.apparatus.pipettes, newObj ]
          } else {
            protocolSection.scene.apparatus.pipettes = [newObj]
          }

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case 'SET_PIPETTE_CONTROLS_VISIBLE':

          // Hide the controls for all the other pipettes
          protocolSection.scene.apparatus.pipettes.forEach((pipette) => {
            pipette.controlsVisible = false;
          })
          // Make the current pipettes controls visible
          currentPipette.controlsVisible = action.payload.controlsVisible
          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case 'HIDE_ALL_CONTROLS':

          // Hide the controls for all the other pipettes
          protocolSection.scene.apparatus.pipettes.forEach((pipette) => {
            pipette.controlsVisible = false;
          })

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case 'SET_HELD':

          // xAPI statement
          // sendxAPI({
          //   // Type of statement
          //   verb: {
          //     description: "held",
          //     address: "https://w3id.org/xapi/dod-isd/verbs/held"
          //   },
          //   // Where the action occured
          //   context: currentPipette.type + " Pipette",
          //   // Result of the action
          //   result: {
          //     success: true,
          //     response: action.payload.held
          //   }
          // })

          currentPipette.held = action.payload.held
          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case 'SET_PIPETTE_ANIMATING_OUT':
          currentPipette.animatingOut = action.payload.animatingOut
          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case 'SET_PIPETTE_PLUNGER_POSITION':

          // xAPI statement
          // sendxAPI({
          //   // Type of statement
          //   verb: {
          //   description: "assigned",
          //   address: "https://w3id.org/xapi/dod-isd/verbs/assigned"
          //   },
          //   // Where the action occured
          //   context: currentPipette.type + " Pipette plunger position",
          //   // Result of the action
          //   result: {
          //   success: true,
          //   response: action.payload.plungerPosition
          //   }
          // })

          currentPipette.plungerPosition = action.payload.plungerPosition
          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case 'SET_PIPETTE_CURRENT_PLUNGER_POSITION':
          currentPipette.currentPlungerPos = action.payload.currentPlungerPos
          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case 'INC_VOL':
          //Increases volume for by volChange
          if ((currentPipette.volume + currentPipette.volChange) <= currentPipette.maxVol) {

              currentPipette.volume += currentPipette.volChange

              //Lodash merge current pipette into pipettes array
              protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette

              return { ...state, ...{
                protocolSection: protocolSection
              } }

          } else {
              return state
          }

      case 'DEC_VOL':
          //Decreases volume for by volChange
          if ((currentPipette.volume - currentPipette.volChange) >= currentPipette.minVol) {

              currentPipette.volume -= currentPipette.volChange

              //Lodash merge current pipette into pipettes array
              protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette

              return { ...state, ...{
                protocolSection: protocolSection
              } }

          } else {
              return state
          }

      case 'SET_PIPETTE_VOL':
          //Set the volume of the pipette
          if ((action.payload.volume >= currentPipette.minVol) && (action.payload.volume <= currentPipette.maxVol)) {

              // xAPI statement
              // sendxAPI({
              //   // Type of statement
              //   verb: {
              //     description: "assigned",
              //     address: "https://w3id.org/xapi/dod-isd/verbs/assigned"
              //   },
              //   // Where the action occured
              //   context: currentPipette.type + " Pipette volume",
              //   // Result of the action
              //   result: {
              //     success: true,
              //     response: action.payload.volume
              //   }
              // })

              currentPipette.volume = action.payload.volume

              //Lodash merge current pipette into pipettes array
              protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette

              return { ...state, ...{
                protocolSection: protocolSection
              } }

          } else {
              return state
          }

      case 'SET_TIP_ATTACHED':

          // xAPI statement
          // sendxAPI({
          //   // Type of statement
          //   verb: {
          //   description: "assigned",
          //   address: "https://w3id.org/xapi/dod-isd/verbs/assigned"
          //   },
          //   // Where the action occured
          //   context: currentPipette.type + " Pipette tip attached",
          //   // Result of the action
          //   result: {
          //   success: true,
          //   response: action.payload.attached
          //   }
          // })

          currentPipette.tipAttached = action.payload.attached

          if(action.payload.attached === false){
            currentPipette.prevSolution = {}
          }

          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case 'SET_TIP_USED':

          currentPipette.tipUsed = action.payload.used
          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette

          return { ...state, ...{
            protocolSection: protocolSection
          } }

      case 'SET_PIPETTE_SOLUTION':

          // xAPI statement
          // sendxAPI({
          //   // Type of statement
          //   verb: {
          //   description: "assigned",
          //   address: "https://w3id.org/xapi/dod-isd/verbs/assigned"
          //   },
          //   // Where the action occured
          //   context: currentPipette.type + " Pipette solution",
          //   // Result of the action
          //   result: {
          //   success: true,
          //   response: (action.payload.solutionAlias !== null) ? action.payload.solutionAlias : "Empty"
          //   }
          // })

          currentPipette.solution = action.payload.solution

          if(action.payload.solution !== null){
            currentPipette.prevSolution = action.payload.solution
          }

          currentPipette.solutionAlias = action.payload.solutionAlias
          protocolSection.scene.apparatus.pipettes[findIndex(state.pipettes, { id: action.payload.id })] = currentPipette

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case "UNDO":
            //Payload = {lastState}

            if (action.payload.lastState !== null) {

              protocolSection.scene.apparatus.pipettes = action.payload.lastState.scene.apparatus.pipettes

              return { ...state, ...{
                protocolSection: protocolSection
              } }

            } else {
              return state;
            }

      default:
          return state;
  }
}
